import { render, staticRenderFns } from "./information.vue?vue&type=template&id=182d6afd&scoped=true&"
import script from "./information.vue?vue&type=script&lang=js&"
export * from "./information.vue?vue&type=script&lang=js&"
import style0 from "./information.vue?vue&type=style&index=0&id=182d6afd&prod&lang=scss&scoped=scoped&"
import style1 from "./information.vue?vue&type=style&index=1&id=182d6afd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182d6afd",
  null
  
)

export default component.exports